const LEGACY_LOCALE_PREFIX = /^\/(en|es|es-mx|hi|de|fr|it|pt-br)(\/.*)?$/i;

export default defineNuxtRouteMiddleware(async (to: any) => {
  // i18n foi removido; bookmarks, Google e afiliados ainda apontam para
  // /en/*, /es/*, etc. Remove o prefixo e mantém o restante do path + query.
  const legacyLocaleMatch = to.path.match(LEGACY_LOCALE_PREFIX);

  if (legacyLocaleMatch) {
    const remainder = legacyLocaleMatch[2] || '/';

    return navigateTo(
      { path: remainder, query: to.query, hash: to.hash },
      { redirectCode: 301 },
    );
  }

  // Campanhas externas às vezes veiculam URLs sem o `?` separando a query
  // (ex.: /deposit=1&value=100). Reescreve para query real na home, para
  // que middlewares como deposit.global.ts consigam ler to.query.
  const malformedQueryMatch = to.path.match(/^\/([a-z][a-z0-9_-]*=.+)$/i);

  if (malformedQueryMatch) {
    const params = new URLSearchParams(malformedQueryMatch[1]);
    const query: Record<string, string> = { ...to.query };

    params.forEach((value, key) => {
      query[key] = value;
    });

    return navigateTo({ path: '/', query }, { redirectCode: 301 });
  }

  // /vip/levels desativado ("Em breve") — bloqueia acesso direto pela URL.
  // Redirect temporário (302) para a home; reverter é só remover este bloco.
  if (to.path === '/vip/levels') {
    return navigateTo('/', { redirectCode: 302 });
  }

  // Indique e Ganhe "Em breve": bloqueia /user/refers enquanto a flag
  // user_refers_coming_soon estiver ativa. Redirect temporário (302) para
  // a home; reverter é só desligar a flag no featureFlags.json.
  if (to.path === '/user/refers') {
    const { isUserRefersComingSoon } = useFeatureFlagsJson();

    if (isUserRefersComingSoon.value) {
      return navigateTo('/', { redirectCode: 302 });
    }
  }

  // temporary redirect banana games
  if (to.path === '/games/banana/starlight-roulette') {
    const { goToLocaleRoute } = useRoutes();

    return await goToLocaleRoute({
      name: 'games-provider-game',
      params: {
        provider: 'playtech',
        game: 'roleta-brasileira',
      },
    });
  }
  if (to.path === '/games/banana/aviator-aposta-tudo-3') {
    const { goToLocaleRoute } = useRoutes();

    return await goToLocaleRoute({
      name: 'games-provider-game',
      params: {
        provider: 'banana',
        game: 'aviaozinho',
      },
    });
  }
  // temporary redirect banana games

  // Redirect /games/category/{categoria} to /games/category/all?initialCategory={categoria}
  const categoryMatch = to.path.match(/^\/games\/category\/(.+)$/);

  if (categoryMatch) {
    const category = categoryMatch[1];

    // Skip if already on /games/category/all
    if (category !== 'all') {
      // Preserve existing query params and add initialCategory
      const query = { ...to.query, initialCategory: category };

      return navigateTo({
        path: '/games/category/all',
        query,
      });
    }
  }
});
